import { logger } from "services/Logger";

export class Signal<T = void> {
  private listeners: Array<(value: T) => void> = [];

  // Event-Listener hinzufügen
  public subscribe(listener: (value: T) => void): { unsubscribe: () => void } {
    this.listeners.push(listener);

    // Rückgabe eines Subscription-Objekts mit unsubscribe-Methode
    return {
      unsubscribe: () => {
        const index = this.listeners.indexOf(listener);
        if (index !== -1) {
          this.listeners.splice(index, 1);
        }
      },
    };
  }

  // Event auslösen und an alle Listener senden
  public emit(value: T): void {
    this.listeners.forEach((listener) => {
      try {
        listener(value);
      } catch (error) {
        logger.error('Error in Signal listener:', error);
      }
    });
  }

  // Alle Listener entfernen
  public clear(): void {
    this.listeners = [];
  }
}
